"use client";
import { ICartItemType } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { ICommonProductDetails } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { currencyAtom } from "@/hooks/currencyAtom";

import { getCartItemFromProductToEvent } from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/helpers/functions";
import { EventType } from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/helpers/interfaces";
import useEventTrackers from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/useEventTrackers";
import { useAtom } from "jotai";
import React, { useEffect } from "react";

const ViewProductPixel = ({ product }: { product: ICommonProductDetails }) => {
  const { eventTrackers } = useEventTrackers();
  const [currency] = useAtom(currencyAtom);
  const handleTimerEnd = () => {
    eventTrackers(
      EventType.VIEW_CONTENT,
      [
        {
          ...(getCartItemFromProductToEvent({
            parent: { name: product.name, sku: product.sku },
            inner_id: product.id,
            discount: product.discount,
            name: product.name,
            type: product.preview_type,
            quantity: 1,
            price: product.price,
            categories_names: product?.categories_names ?? [],
            attrs_values: product.attributes_builder.map((attr) => ({
              name: attr.configurations.title,
            })),
          }) as unknown as ICartItemType),
        },
      ],
      {
        value: product?.price,
        currency: currency?.code,
        discount: product?.discount,
      },
    );
  };

  useEffect(() => {
    if (!product) return;
    let time = 1;
    const timerId = setInterval(() => {
      if (time === 0) {
        clearInterval(timerId);
        handleTimerEnd();
      } else {
        time -= 1;
      }
    }, 1000);

    return () => clearInterval(timerId);
  }, [product]);

  return <></>;
};

export default ViewProductPixel;
